import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAutomaticComponent } from './simple-icons-automatic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAutomaticComponent ],
    exports:      [ SimpleIconsAutomaticComponent ],
    bootstrap:    []
})
export class SimpleIconsAutomaticModule {}
